// Admin utilities and shared config
import axios from 'axios';

// Use relative URL in production, full URL in development
export const API = window.location.hostname === 'localhost' 
  ? `${process.env.REACT_APP_BACKEND_URL}/api`
  : '/api';

// Get auth headers
export const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('admin_token')}`
});

// Format date for display
export const formatDate = (dateStr) => {
  if (!dateStr) return 'Unknown';
  return new Date(dateStr).toLocaleDateString('en-US', { 
    month: 'short', day: 'numeric', year: 'numeric' 
  });
};

// API helper with auth
export const adminApi = {
  get: (url) => axios.get(`${API}${url}`, { headers: getAuthHeaders() }),
  post: (url, data = {}) => axios.post(`${API}${url}`, data, { headers: getAuthHeaders() }),
  put: (url, data = {}) => axios.put(`${API}${url}`, data, { headers: getAuthHeaders() }),
  delete: (url) => axios.delete(`${API}${url}`, { headers: getAuthHeaders() }),
  upload: (url, formData) => axios.post(`${API}${url}`, formData, {
    headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' }
  })
};
